/*
vue-i18n (v8.x) guide
https://kazupon.github.io/vue-i18n/guide/formatting.html
*/
import { formattedDate } from './dateTimeFormatter.ts';

const enUS = {
    datetime: ({ named }) =>
        formattedDate(
            named('date'),
            named('format'),
            named('locale') ? named('locale') : 'en-US',
            named('customFormat')
        ),
};
export default enUS;
